<template>
    <div class="modal fade" ref="emailSignatureModal" tabindex="-1" role="dialog" aria-labelledby="video1" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <a type="button" class="modal-close-btn" data-dismiss="modal"><img src="/images/global/close-icon.svg"></a>
                    <div class="modal-heading">
                        Signature Link Generator
                    </div>
                    <div>
                        <div class="d-flex justify-content-center align-items-center mb-5 flex-column">
                            <template v-if="employee.access_level === 'AD'">
                                <table class="table-borderless mb-5" border="0" cellpadding="0" cellspacing="0" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%;" width="100%" ref="image">
                                    <tr>
                                        <td align="left" class="text-center" style="padding: 0 0 10px 0;">
                                            <a :href="`https://www.acg.aaa.com/cc/apply?flowid=X4WZ3YGLYE31J22&pid=${this.employee.employee_id}`" >
                                                <img class="mx-auto" :src="`${host}/images/education/ACG_signature_branch.jpg`" alt="">
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="left" class="text-center">
                                            <a :href="`https://www.acg.aaa.com/cc/apply?flowid=VC28Q3PA6158EM1&pid=${this.employee.employee_id}`">
                                                <img class="mx-auto" :src="`${host}/images/education/ACG_signature_cc.jpg`" alt="">
                                            </a>
                                        </td>
                                    </tr>
                                </table>
                            </template>
                            <template v-else>
                                <a ref="image" class="mb-5" :href="applyUrl">
                                    <img class="mx-auto" :src="image" alt="">
                                </a>
                            </template>

                            <template v-if="error">
                                <p class="text-danger">{{ error }}</p>
                            </template>
                            <button v-else @click="copyImage" class="btn btn-primary signature-link" :data-channel="employee.channel">
                                <template v-if="copied">
                                    Copied!
                                </template>
                                <template v-else>
                                    Copy Image
                                </template>
                            </button>
                        </div>
                    </div>
                        <div>
                            <p class="small">Note: For compliance purposes, no credit card taglines or promotional verbiage may be added to your email signature.</p>
                            <p class="nav-heading mb-0">Step 1 - Copy the custom image</p>
                            <ul class="list-group mb-3">
                                <li class="list-group-item">Your custom credit card image was generated above.</li>
                                <li class="list-group-item">Copy the image by clicking the "Copy Image" button.</li>
                            </ul>
                            <p class="nav-heading mb-0">Step 2 - Immediately go to Outlook</p>
                            <ul class="list-group mb-3">
                                <li class="list-group-item">Paste (CTRL + V) the custom image in the desired new or existing signature block.</li>
                                <li class="list-group-item">Verify the default settings are set to include this new/modified signature block as appropriate.</li>
                            </ul>
                            <p class="nav-heading">You are done! The custom image will appear in your emails as you designated above. Click "X" to close this window</p>
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import eventBus from '@/event-bus';
import copy from 'copy-to-clipboard';
import ItemDownloadService from '@/services/item-download.service.js';

export default {
    props: {
        employee: {
            type: Object,
            default() {
                return {}
            }
        },
        env: {
            type: String,
            default: 'production'
        }
    },
    data() {
        const host = window.location.origin;

        return {
            host: host,
            copied: false,
            image: this.employee.channel === 'Contact Center' ? `${host}/images/education/ACG_signature_cc.jpg` : `${host}/images/education/ACG_signature_branch.jpg` ,
            applyUrl: this.employee.channel === 'Contact Center' ? `https://www.acg.aaa.com/cc/apply?flowid=VC28Q3PA6158EM1&pid=${this.employee.employee_id}` : `https://www.acg.aaa.com/cc/apply?flowid=X4WZ3YGLYE31J22&pid=${this.employee.employee_id}`,
            error: '',
        }
    },
    mounted() {
        eventBus.$on('emailSignatureModalOpened', this.openModal);

        $(this.$refs.emailSignatureModal).on('hidden.bs.modal', () => {
            this.copied = false;
            this.error = '';
        });
    },
    methods: {
        openModal() {
            $(this.$refs.emailSignatureModal).modal('show');
        },
        async copyImage() {
            try {
                await ItemDownloadService.store({path: this.applyUrl});
            } catch (error) {

            } finally {
                copy(this.$refs.image.outerHTML, {
                    format: 'text/html'
                });

                this.copied = true;
            }
        }
    }
}
</script>
